const lightTheme = {
    current: "light",
    images: {
        logoFullHorizontalTransparent: '/logo/logo-full-horizontal-transparent-dark-900px.png',
        logoFullHorizontalTransparentOriginal: '/logo/logo-full-horizontal-transparent-dark-original.png',
        logoFullHorizontalTransparentSvg: '/logo/logo-full-horizontal-transparent-dark.svg',
        logoFullSquareTransparent: '/logo/logo-full-square-transparent-dark-2000px.png',
        logoFullSquareTransparentOriginal: '/logo/logo-full-square-transparent-dark-original.png',
        logoFullSquareTransparentSvg: '/logo/logo-full-square-transparent-dark.svg',
        logoPrimaryHorizontal: '/logo/logo-primary-horizontal-dark-2000px.png',
    },
    colors: {
        text: '#000000',
        textAlt: 'white',

        headerBg: '#F5F9FA',
        logoBg: '#F5F9FA',
        //background: '#FFFFFF',

        // brandSubmit: '#42E196',
        buttonPrimary: '#68ADB7',
        buttonPrimaryText: '#F5F9FA',
        buttonPrimaryTextHover: 'white',
        menuBg: '#F5F9FA',
        menuText: '#212447',
        borderContrast: '#212447',
        landingFormActive: '#68ADB7',

        brandPrimary: '#212447',
        brandSecondary: '#68ADB7',
        primary: '#68A#68ADB7DB7',
        secondary: '#212447',
        // primaryHover:'#21D480',
        secondaryHover:'#68ADB7',

        brandTertiary: '#3DD4AD',
        brandTertiaryHover:'#2CC9A2',
        // Add more colors as needed

        brandInfo: '#68ADB7',
        brandSuccess: '#00C851',
        brandWarning: '#FFBB33',
        brandError: '#FF4444',

        quickActionIcon: '#ffd930',

        // Disabled states
        textDisabled: '#888',
        borderDisabled: '#888',

        // Background variants
        backgroundPrimary: '#F5F9FA',
        backgroundSecondary: '#68ADB7',
        background: '#68ADB7',
        backgroundAlt: '#f5f5f5',
        backgroundTertiary: '#f8f9fa',
        tableBackground: 'white',

        // Border colors
        border: '#ccc',
        borderLight: '#eee',
        borderDark: '#000',
        headerBorder: '#68ADB7', // Same as dark theme for consistency

        // Overlay colors
        overlayHover: 'rgba(0, 0, 0, 0.04)',
        overlayDisabled: 'rgba(0, 0, 0, 0.26)',
        overlayTextDisabled: 'rgba(0, 0, 0, 0.5)',

        // Warning variant (for cooldown warnings)
        brandWarningLight: 'rgba(255, 193, 7, 0.9)',
    },
    fonts: {
        primary: 'League Spartan',
    },
    spacing: {
        small: '8px',
        medium: '16px',
        large: '24px',
        // Add more spacing sizes as necessary
    },
    shadows: {
        sidebar: '4px 0 8px rgba(0, 0, 0, 0.15), -4px 0 8px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.15)',
        table: '0 4px 12px rgba(0, 0, 0, 0.15)',
        form: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    // Text shadow using text color (light mode: 15% opacity)
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.15), 1px 0 2px rgba(0, 0, 0, 0.15), 0.5px 0.5px 1.5px rgba(0, 0, 0, 0.15)',
    // Add any other lightTheme properties you need
};

export default lightTheme;


// TODO : much darker bg #00120B
// TODO : good dark theme background #061A40
// TODO : lighter option as a foreground? #1C2541
